import { TWidget } from 'widgets/Widget';
/**
 * @description Base DrawerDialogToggle implementation
 * @param Widget Base for extending
 * @returns DrawerDialogToggle class
 */

function DrawerDialogToggleClassCreator(Widget: TWidget) {
    /**
     * @category widgets
     * @subcategory header
     * @class DrawerDialogToggle
     * @classdesc Trigger drawer panel
     * @augments Modal
     */
    class DrawerDialogToggle extends Widget {
        prefs() {
            return {
                ...super.prefs()
            };
        }
        /**
         * @description Widget initialization logic
         * @listens "drawer.show"
         */

        init() {
            super.init();
        }
        /**
         * @description Shows drawer dialog
         */

        showDrawerDialogToggle() {
            this.eventBus().emit('drawer.show');
        }
    }

    return DrawerDialogToggle;
}

export type TDrawerDialogToggle = ReturnType<typeof DrawerDialogToggleClassCreator>;
export type TDrawerDialogToggleInstance = InstanceType<TDrawerDialogToggle>;
export default DrawerDialogToggleClassCreator;
